import { render } from "./Reg.vue?vue&type=template&id=463a87b0&scoped=true"
import script from "./Reg.vue?vue&type=script&lang=js"
export * from "./Reg.vue?vue&type=script&lang=js"

import "./Reg.vue?vue&type=style&index=0&id=463a87b0&lang=scss&scoped=true"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-463a87b0"]])

export default __exports__